// PrivacyPolicyModal.jsx
import React from "react";
import styled from "styled-components";

export const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h2>개인정보처리방침</h2>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <PrivacyContent>
            <p>
              관세법인 에이원(이하 '회사'라 함)은 회원의 개인정보 보호를 매우
              중요시하며, "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 및
              전기통신사업법, 통신비밀보호법을 준수하고 있습니다.
            </p>

            <p>
              회사는 개인정보처리방침을 수립하여 회원의 개인정보를 보호하고
              있으며, 이를 홈페이지에 명시하여 회원이 온라인상에서 회사에 제공한
              개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를
              위해 어떠한 조치를 취하는지 알려드립니다.
            </p>

            <p>회사의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.</p>

            <ul>
              <li>1. 수집하는 개인정보 항목 및 수집방법</li>
              <li>2. 개인정보의 수집 및 이용목적</li>
              <li>3. 수집한 개인정보의 보유 및 이용기간</li>
              <li>4. 수집한 개인정보의 공유 및 제공</li>
              <li>5. 수집한 개인정보 취급위탁</li>
              <li>6. 개인정보의 파기 절차 및 방법</li>
              <li>7. 이용자 및 법정대리인의 권리와 그 행사방법</li>
              <li>
                8. 개인정보 자동수집장치의 설치, 운영 및 그 거부에 관한 사항
              </li>
              <li>9. 개인정보의 기술적, 관리적 보호 대책</li>
              <li>10. 개인정보 관리 책임자 및 담당자의 소속-성명 및 연락처</li>
              <li>11. 개인정보관련 신고 및 분쟁조정</li>
              <li>12. 고지의 의무</li>
            </ul>

            <h3>1장. 수집하는 개인정보 항목 및 수집방법</h3>

            <p>
              '개인정보’란 생존하는 개인에 관한 정보로서 성명, 주민등록번호 등에
              의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정
              개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여
              알아볼 수 있는 것을 포함)를 말합니다.
            </p>

            <h4>1. 수집하는 개인정보 항목</h4>
            <p>
              ① 회사는 회원가입 및 서비스 신청, 고객상담 등을 위해 아래와 같은
              개인정보를 수집하고 있습니다.
            </p>

            <ul>
              <li>회원가입 시</li>
              <ul>
                <li>
                  &lt;일반 회원가입 시&gt; : 이름, 주민등록번호(외국인의 경우
                  여권번호 또는 외국인등록번호), 아이디, 비밀번호, 이메일주소,
                  전화번호(휴대전화번호 또는 유선전화번호), 법정대리인 정보(만
                  14세 미만인 아동의 경우)
                </li>
                <li>
                  &lt;아이핀(I-PIN) 회원가입 시&gt; : 이름, 생년월일, 성별,
                  아이핀 번호, 아이디, 중복가입확인 정보(D.I값), 비밀번호,
                  이메일 주소, 전화번호(휴대전화번호 또는 유선전화번호),
                  법정대리인 정보(만 14세 미만의 아동인 경우)
                </li>
              </ul>
              <li>
                일부 서비스 신청 시 : 주소, 사업자 관련 정보(상호,
                사업자등록번호, 대표자 이름, 사업장
                주소/전화번호/팩스번호/이메일주소, 홈페이지 주소, 통신판매업
                신고번호)
              </li>
              <li>환불 시 : 계좌정보(거래은행명, 계좌번호, 거래자 성명)</li>
            </ul>

            <p>
              ② 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이
              생성되어 수집될 수 있습니다.
            </p>
            <ul>
              <li>
                서비스 이용기록, 접속로그, 쿠키, 접속IP 정보, 결제기록,
                이용정지기록, 불량이용기록
              </li>
            </ul>

            <h4>2. 개인정보 수집방법</h4>
            <ul>
              <li>① 홈페이지, 서면양식을 통한 회원가입</li>
              <li>
                ② 전화, 팩스, 상담게시판을 통한 고객상담 및 서비스 이용관리
              </li>
              <li>③ 이벤트(경품행사) 응모, 배송요청</li>
              <li>④ 제휴사로부터의 제공</li>
              <li>⑤ 생성정보 수집툴을 통한 수집</li>
            </ul>

            <h3>2장. 개인정보 수집 및 이용목적</h3>

            <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>

            <ul>
              <li>
                <b>
                  1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
                </b>
                <br />
                서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증,
                구매 및 요금 결제, 요금추심
              </li>
              <li>
                <b>2. 회원관리</b>
                <br />
                회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의
                부정이용 방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입횟수
                제한, 만 14세 미만 아동의 개인정보 수집 시 법정대리인 동의여부
                확인, 추후 법정대리인 본인확인, 분쟁조정을 위한 기록 보존,
                불만처리 등 민원처리, 고지사항 전달
              </li>
              <li>
                <b>3. 신규서비스 개발 및 마케팅, 광고</b>
                <br />
                신규서비스(제품) 개발 및 특화, 인구통계학적 특성에 따른 서비스
                제공 및 광고 게재, 접속빈도 파악, 회원의 서비스 이용에 대한
                통계, 이벤트 등 광고성 정보 전달
              </li>
            </ul>

            <h3>3장. 수집한 개인정보의 보유 및 이용기간</h3>

            <p>
              원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를
              지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로
              명시한 기간 동안 보존합니다.
            </p>

            <h4>1. 회사 내부방침에 의한 정보보유 사유</h4>
            <ul>
              <li>
                회원이 탈퇴한 경우에도 회사는 원활한 서비스의 제공 및 부정한
                서비스의 이용을 방지하기 위하여 아래와 같이 회원정보를
                보관합니다.
              </li>
              <ul>
                <li>
                  이름, 주민등록번호(여권번호/외국인등록번호), 이메일 주소,
                  전화번호
                </li>
                <li>
                  보존이유 : 서비스 이용의 혼선방지, 분쟁해결 및 수사기관의
                  요청에 따른 협조
                </li>
                <li>보존기간 : 1년</li>
              </ul>
              <li>부정/불량이용기록 (부정/불량이용자의 개인정보 포함)</li>
              <ul>
                <li>
                  보존이유 : 서비스의 부정 및 불량 이용 방지 및
                  부정/불량이용자의 재가입 방지
                </li>
                <li>보존기간 : 1년</li>
              </ul>
            </ul>

            <h4>2. 관련 법령에 의한 정보보유 사유</h4>
            <ul>
              <li>
                계약 또는 청약철회 등에 관한 기록 — 5년 (전자상거래 등에서의
                소비자보호에 관한 법률)
              </li>
              <li>대금결제 및 재화 등의 공급에 관한 기록 — 5년</li>
              <li>소비자의 불만 및 분쟁처리에 관한 기록 — 3년</li>
              <li>로그기록 — 3개월 (통신비밀보호법)</li>
            </ul>

            <h3>4장. 개인정보의 공유 및 제공</h3>

            <p>
              회사는 회원의 개인정보를 수집 및 이용목적으로 정한 범위 내에서
              사용하며, 동 범위를 초과하여 이용하거나 외부에 공개/제공하지
              않습니다. 다만, 아래의 경우에는 예외로 합니다.
            </p>

            <ul>
              <li>
                1. 제3자에게 제공하거나 공유하는 것에 대하여 회원이 사전에
                동의한 경우
              </li>
              <li>
                2. 법령의 규정에 의거하거나, 수사목적으로 법령에 정해진 절차와
                방법에 따라 수사기관의 요구가 있는 경우
              </li>
            </ul>

            <h3>5장. 수집한 개인정보 취급위탁</h3>

            <p>
              회사는 고객서비스 관리 및 민원사항에 대한 처리 등 원활한 업무
              수행을 위하여 아래와 같이 개인정보 취급 업무를 위탁하여 운영하고
              있습니다. 또한 위탁계약 시 개인정보보호의 안전을 기하기 위하여
              개인정보보호 관련 법규의 준수, 개인정보에 관한 제3자 공급 금지 및
              사고 시의 책임부담 등을 명확히 규정하고 있습니다. 동 업체가 변경될
              경우, 변경된 업체명을 공지사항 내지 개인정보처리방침 화면을 통해
              고지하겠습니다.
            </p>

            <h3>6장. 개인정보 파기 절차 및 방법</h3>

            <h4>1. 파기절차</h4>
            <ul>
              <li>
                ① 회원이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후
                내부방침 및 기타 관련법령에 의한 정보보호 사유에 따라 일정 기간
                저장된 후 파기됩니다.
              </li>
              <li>
                ② 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는
                이외의 다른 목적으로 이용되지 않습니다.
              </li>
            </ul>

            <h4>2. 파기방법</h4>
            <ul>
              <li>
                ① 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여
                파기합니다.
              </li>
              <li>
                ② 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
                기술적 방법을 사용하여 삭제합니다.
              </li>
            </ul>

            <h3>7장. 회원 및 법정대리인의 권리와 그 행사방법</h3>

            <ul>
              <li>
                1. 회원 및 법정대리인은 언제든지 등록되어 있는 자신 또는 당해
                만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며
                가입해지(동의철회)를 요청할 수도 있습니다.
              </li>
              <li>
                2. 회원 또는 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
                “회원정보수정”을, 가입해지(동의철회)를 위해서는 “회원탈퇴”를
                클릭하여 본인 확인절차를 거치신 후 직접 열람, 정정 또는 탈퇴가
                가능합니다.
              </li>
              <li>
                3. 오류 정정 요청 시 정정 완료 전까지 개인정보 이용 또는 제공을
                중단합니다.
              </li>
              <li>
                4. 해지 또는 삭제된 개인정보는 “3. 수집한 개인정보의 보유 및
                이용기간”에 따라 처리하고 열람 또는 이용할 수 없습니다.
              </li>
            </ul>

            <h3>
              8장. 개인정보의 자동수집장치의 설치/운영 및 그 거부에 관한 사항
            </h3>

            <p>
              회사는 회원에게 개별적으로 특화된 맞춤서비스를 제공하기 위해서
              쿠키(cookie)를 사용합니다.
            </p>

            <h4>1. 쿠키 등 사용목적</h4>
            <p>
              회원과 비회원의 접속빈도나 방문시간 등을 분석, 이용자의 취향과
              관심분야를 파악 및 자취 추적 각종 이벤트 참여 정도 및 방문 횟수
              파악 등을 통한 타깃 마케팅 및 개인맞춤서비스제공
            </p>

            <h4>2. 쿠키설정거부방법</h4>
            <p>
              회원은 쿠키 설치에 대한 선택권을 가지고 있습니다. 웹브라우저에서
              옵션을 설정하여 쿠키를 허용, 확인, 또는 거부할 수 있습니다.
            </p>

            <p>
              <b>설정방법 예:</b> (인터넷 익스플로러의 경우) 웹브라우저 상단의
              도구 &gt; 인터넷 옵션 &gt; 개인정보
            </p>

            <p>
              단, 쿠키를 거부할 경우 로그인이 필요한 서비스 이용이 어려울 수
              있습니다.
            </p>

            <h3>9장. 개인정보보호 관련 기술적/관리적 대책</h3>

            <h4>1. 기술적 대책</h4>
            <ul>
              <li>① 비밀번호는 암호화되어 저장됩니다.</li>
              <li>② 백신프로그램을 이용하여 개인정보 손상 방지</li>
              <li>③ 네트워크상 보안장치 채택</li>
              <li>④ 침입차단시스템(방화벽)을 이용하여 외부 무단 접근 통제</li>
            </ul>

            <h4>2. 관리적 대책</h4>
            <ul>
              <li>① 본인확인 절차 강화</li>
              <li>② 개인정보 접근권한 제한 및 정기 교육 시행</li>
            </ul>

            <p>
              회원은 아이디, 비밀번호 등의 개인정보가 유출되지 않도록 주의해야
              하며, 회사는 회원의 부주의로 인한 유출에 책임을 지지 않습니다.
            </p>

            <h3>10장. 개인정보 관리 책임자 및 담당자</h3>

            <ul>
              <li>CPO 박찬욱 대표관세사</li>
              <li>전화: 02-2017-3327</li>
              {/* <li>① 이 름 :</li>
              <li>② 소 속 :</li>
              <li>③ 직 위 :</li>
              <li>④ 전 화 :</li>
              <li>⑤ email :</li> */}
            </ul>

            <p>
              문의사항은 개인정보관리 책임자 혹은 담당자에게 연락하시면 신속하게
              답변드리겠습니다.
            </p>

            <h3>11장. 개인정보관련 신고 및 분쟁조정</h3>

            <ul>
              <li>
                개인정보 침해신고센터 (
                <a href="http://www.cyberprivacy.or.kr">
                  http://www.cyberprivacy.or.kr
                </a>
                , 전화 1336)
              </li>
              <li>
                개인정보 분쟁조정위원회 (
                <a href="http://www.kopico.or.kr">http://www.kopico.or.kr</a>,
                전화 1336)
              </li>
              <li>
                정보보호마크 인증위원회 (
                <a href="http://www.privacymark.or.kr">
                  http://www.privacymark.or.kr
                </a>
                , 전화 02-580-0533)
              </li>
              <li>
                대검찰청 인터넷범죄수사센터 (
                <a href="http://www.spo.go.kr">http://www.spo.go.kr</a>, 전화
                02-3480-3600)
              </li>
              <li>
                경찰청 사이버테러대응센터 (
                <a href="http://www.ctrc.go.kr">http://www.ctrc.go.kr</a>, 전화
                02-392-0330)
              </li>
              <li>
                경찰청 (
                <a href="http://www.police.go.kr">http://www.police.go.kr</a>)
              </li>
            </ul>

            <h3>12장. 정책변경에 따른 고지의 의무</h3>

            <p>
              법령, 정책 또는 보안기술 등의 변경에 따라 현 개인정보처리방침의
              내용 추가, 삭제 및 수정이 있을 시에는 개정되는 개인정보처리방침을
              시행하기 최소 7일 전에 홈페이지의 '공지사항'을 통해 고지할
              것입니다.
            </p>

            <h4>[부칙]</h4>
            <ul>
              <li>1. 공고일자 : 2020.02.17</li>
              <li>2. 시행일자 : 2020.02.17</li>
            </ul>
          </PrivacyContent>
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(11, 22, 61, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 16px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(11, 22, 61, 0.3);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #14245c;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #1f2937;
  }
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
`;

const PrivacyContent = styled.div`
  line-height: 1.6;
  color: #374151;

  h3 {
    margin-top: 3rem;
  }

  strong {
    color: #1f2937;
  }
`;
